import React from 'react';
import { signInWithGoogle } from '../utils/firebase';

export default function LandingScreen() {
  const handleSignIn = async () => {
    try {
      await signInWithGoogle();
      // Auth state listener in App.js will handle navigation
    } catch (error) {
      console.error('Sign in failed:', error);
      alert('Sign in failed. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-purple-900 flex items-center justify-center p-4">
      <div className="text-center max-w-2xl">
        <div className="mb-8">
          <h1 className="text-6xl font-bold mb-4 bg-gradient-to-r from-purple-400 to-pink-400 text-transparent bg-clip-text">
            SpeechTrack
          </h1>
          <p className="text-xl text-gray-300 mb-8">
            Never miss a key point in your speech again
          </p>
        </div>
        
        <button
          onClick={handleSignIn}
          className="bg-white text-gray-900 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl inline-flex items-center gap-3"
        >
          <span className="text-2xl">G</span>
          Sign in with Google
        </button>
        
        <p className="text-gray-400 text-sm mt-6">
          Free to use • No credit card required
        </p>
      </div>
    </div>
  );
}